import { Component, OnInit } from '@angular/core';
import { TechfinanceService } from 'src/app/services/techfinance.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-initial',
  templateUrl: './initial.component.html',
  styleUrls: ['./initial.component.scss'],
})
export class InitialComponent implements OnInit {
  token: string = '';
  wealthName = ''

  constructor() {}

  ngOnInit(): void {
    this.token = getCookie('token');
    this.checkToken();
    this.wealthName = getCookie('wealthName');
  }

  checkToken(): void {
    if (!this.token) {
      window.location.href = 'https://qa.techfinance.com.br';
    }
  }
}
